import React, { useEffect, useState } from 'react';
import { DRINK_DISCOVERY_EVENT } from '../../utils/drinkDiscovery';

export default function DiscoveryToast() {
  const [message, setMessage] = useState(null);

  useEffect(() => {
    let timer;
    const onDiscovery = ({ detail }) => {
      window.clearTimeout(timer);
      const drinkName = String(detail?.drink_name || 'dieses Getränk');
      const revoked = Boolean(detail?.discovery_revoked);
      const first = Boolean(detail?.first_discovery);
      const supportRemoved = Boolean(detail?.support_removed);
      setMessage({
        text: revoked ? 'Entdeckung zurückgenommen' : (first ? 'Neue Entdeckung!' : (supportRemoved ? 'Fund gelöscht' : 'Fund gespeichert')),
        detail: revoked
          ? `Für ${drinkName} besteht kein gespeicherter Fund mehr.`
          : (first
            ? `${drinkName} wurde deinem Getränke-Logbuch hinzugefügt.`
            : (supportRemoved ? `${drinkName} bleibt durch weitere Funde in deinem Logbuch.` : 'Dein Getränke-Logbuch wurde aktualisiert.')),
        xp: Number(detail?.xp_awarded || 0) + Number(detail?.xp_reversed || 0),
      });
      timer = window.setTimeout(() => setMessage(null), 3600);
    };
    window.addEventListener(DRINK_DISCOVERY_EVENT, onDiscovery);
    return () => { window.clearTimeout(timer); window.removeEventListener(DRINK_DISCOVERY_EVENT, onDiscovery); };
  }, []);

  if (!message) return null;
  return (
    <div className="pfp-discovery-toast" role="status" aria-live="polite">
      <span aria-hidden="true">🏴‍☠️</span>
      <span><strong>{message.text}</strong><br />{message.detail}</span>
      {message.xp !== 0 ? <span>{message.xp > 0 ? '+' : ''}{message.xp} XP</span> : null}
    </div>
  );
}
